export default "__VITE_ASSET__B6d8dp1___"